import { DistanceUnit } from '@backend/lib-l10n-logic';

type DistanceConfig = {
  minDistance: number;
  maxDistance: number;
  unit: DistanceUnit;
};

const defaultDistanceConfig: DistanceConfig = {
  minDistance: 1,
  maxDistance: 50,
  unit: DistanceUnit.KM,
};

const distanceConfigByCountry: Record<string, DistanceConfig> = {
  FR: { ...defaultDistanceConfig },
  IT: { ...defaultDistanceConfig },
  US: { ...defaultDistanceConfig, unit: DistanceUnit.MI },
};

export const getDistanceConfig = (country: string): DistanceConfig =>
  distanceConfigByCountry[country] || defaultDistanceConfig;
